const modalNames = {
  ADD_INTEGRATION_APP: 'ADD_INTEGRATION_APP',
  ADD_AVATAR_IMAGE: 'ADD_AVATAR_IMAGE',
  ARCHVE_CHANNEL: 'ARCHVE_CHANNEL',
  CREATE_SLASH_COMMAND: 'ADD_INTEGRATION_APP_COMMAND',
  ADD_FAVORITE_CHANNEL: 'ADD_FAVORITE_CHANNEL',
  ADD_FAVORITE_FOLDER: 'ADD_FAVORITE_FOLDER',
  ADD_FAVORITE_MEMBER: 'ADD_FAVORITE_MEMBER',
  ADD_FOLLOWING_MEMBER: 'ADD_FOLLOWING_MEMBER',
  ADD_FOLLOWING_PRIVATE: 'ADD_FOLLOWING_PRIVATE',
  ALERT: 'ALERT',
  CONFIRM: 'CONFIRM',
  CONVERSION_NOTICE: 'CONVERSION_NOTICE',
  UPDATE_CHANNEL: 'UPDATE_CHANNEL',
  CHANGE_FAVORITE_TITLE: 'CHANGE_FAVORITE_TITLE',
  CHANNEL_IMAGE_PICKER: 'CHANNEL_IMAGE_PICKER',
  LOG_FORWARD_CHANNEL_SELECT: 'LOG_FORWARD_CHANNEL_SELECT',
  MAIL_CHANNEL_SETTING: 'MAIL_CHANNEL_SETTING',
  CHANNEL_SLASH_COMMANDS: 'MANAGE_CHANNEL_INTEGRATION',
  EDIT_SLASH_COMMAND: 'EDIT_INTEGRATION_APP_COMMAND',
  CREATE_DIRECT_CHANNEL: 'CREATE_DIRECT_CHANNEL',
  CREATE_TOPIC_CHANNEL: 'CREATE_TOPIC_CHANNEL',
  CONVERSATION_LIMIT_MY_SELF: 'CONVERSATION_LIMIT_MY_SELF',
  COMMAND_ACTION: 'COMMAND_ACTION',
  DELETE_INTEGRATION_APP: 'DELETE_INTEGRATION_APP',
  EDIT_INTEGRATION_APP: 'EDIT_INTEGRATION_APP',
  GLOBAL_SETTING: 'GLOBAL_SETTING',
  IMAGE_EDITOR: 'IMAGE_EDITOR',
  IMAGE_PREVIEW: 'IMAGE_PREVIEW',
  INCOMING_HOOK_INTEGRATION: 'INCOMING_HOOK_INTEGRATION',
  INVITE_TENANT_MEMBERS: 'INVITE_TENANT_MEMBERS',
  INVITE_TENANT_MEMBERS_RESULT: 'INVITE_TENANT_MEMBERS_RESULT',
  CHANNEL_INVITE: 'CHANNEL_INVITE',
  CHANNEL_INVITE_COMMAND: 'CHANNEL_INVITE_COMMAND',
  REMOVE_LOG: 'REMOVE_LOG',
  REMOVE_CHANNEL_IMAGE: 'REMOVE_CHANNEL_IMAGE',
  NOTICE: 'NOTICE',
  PAYMENT_ALERT: 'PAYMENT_ALERT',
  PROFILE: 'PROFILE',
  RECONNECT: 'RECONNECT',
  SEARCH_MEMBER_AND_SELECT_ACTION: 'SEARCH_MEMBER_AND_SELECT_ACTION',
  SESSION_OUT_MODAL: 'SESSION_OUT_MODAL',
  SHARE_CHANNEL_MODAL: 'SHARE_CHANNEL_MODAL',
  SMS: 'SMS',
  QUICK_SWITCHER: 'QUICK_SWITCHER',
  MANAGE_HIDDEN_CHANNEL: 'MANAGE_HIDDEN_CHANNEL',
  METERING_USAGE_ALERT: 'METERING_USAGE_ALERT',
};
export default modalNames;
